<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="19.166" y="16.001" width="14.6667" height="1.25" :fill="color" />
    <rect x="19.166" y="13.334" width="12" height="1.25" :fill="color" />
    <rect
      x="28.333"
      y="4.16699"
      width="5.41667"
      height="5.41667"
      fill="#3EA827"
    />
    <rect x="19.166" y="18.667" width="12" height="1.25" :fill="color" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.83301 6.66699H8.33301V11.6672H13.3328V6.66715H15.8328V20.0005H13.3328V14.1672H8.33301V20.0003H5.83301V6.66699Z"
      :fill="color"
    />
    <rect
      x="13.7497"
      y="25.4167"
      width="12.5"
      height="5"
      :stroke="color"
      stroke-width="0.833333"
    />
    <path
      opacity="0.2"
      d="M14.166 26.667L25.8327 26.667V28.3337L14.166 28.3337V26.667Z"
      :fill="color"
    />
    <rect
      x="18.333"
      y="30.833"
      width="3.33333"
      height="8.33333"
      :fill="color"
    />
    <rect
      x="1.66634"
      y="0.833333"
      width="36.6667"
      height="25"
      rx="0.833333"
      :stroke="color"
      stroke-width="1.66667"
    />
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: "#5C5957",
    },
  },
};
</script>
